// import React, {useEffect, useState} from "react";
// import "./Gallery.css";
// import "yet-another-react-lightbox/styles.css";
// import ApiService from "../../../network/ApiService";
// import {useSelector} from "react-redux";
// import "yet-another-react-lightbox/plugins/thumbnails.css";

// function Gallery() {
//     const {
//         fetchNewsUpdates,
//         fetchContact,
//         fetchAboutUs,
//         fetchSliderImages,
//         fetchStaffs,
//         fetchGalleries,
//     } = ApiService();
//     const {organizationId} = useSelector((state) => state.organization);
//     const languageStatus = sessionStorage.getItem("language");
//     const [open, setOpen] = useState(false);
//     const [slides, setSlides] = useState([
//         {
//             src: "https://cdn.pixabay.com/photo/2016/12/17/14/33/wave-1913559_960_720.jpg",
//             alt: "image",
//             width: 3840,
//             height: 2560,
//         },
//         {
//             src: "https://cdn.pixabay.com/photo/2016/04/15/04/02/water-1330252_960_720.jpg",
//             alt: "image",
//             width: 3840,
//             height: 2560,
//         },
//         {
//             src: "https://cdn.pixabay.com/photo/2016/11/06/05/36/lake-1802337_960_720.jpg",
//             alt: "image",
//             width: 3840,
//             height: 2560,
//         },
//         {
//             src: "https://cdn.pixabay.com/photo/2013/10/09/02/27/lake-192990_960_720.jpg",
//             alt: "image",
//             width: 3840,
//             height: 2560,
//         },
//         {
//             src: "https://cdn.pixabay.com/photo/2014/10/26/17/19/fisherman-504098_960_720.jpg",
//             alt: "image",
//             width: 3840,
//             height: 2560,
//         },
//         {
//             src: "https://cdn.pixabay.com/photo/2016/10/22/15/32/water-1761027_960_720.jpg",
//             alt: "image",
//             width: 3840,
//             height: 2560,
//         },
//     ]);

//     const [galleryData, setGalleryData] = useState([]);

//     const fetchGalleryImages = async () => {
//         try {
//             const response = await fetchGalleries();
//             setGalleryData(response.data.messageWithImg);
//         } catch (error) {
//             console.log(error.message);
//         }
//     };

//     const handleViewSlides = (galleryImages) => {
//         const images = [];
//         galleryImages.map((value, item) => {
//             images.push({
//                 src: value,
//                 alt: "image",
//                 width: 3840,
//                 height: 2560,
//             });
//         });
//         setSlides(images);
//         setOpen(!open);
//     };

//     // useEffect(()=>{
//     //   if (slides.length > 0) {

//     //   }
//     // },[slides])
  
//     useEffect(() => {
//         if (organizationId) {
//             fetchGalleryImages();
//         }
//     }, [organizationId]);

//     return (
//         <>
 
//             <div className="uk-section-small uk-section-default section-contact">
//             <div className="uk-container">
//                 <h2
//                     className="uk-h2 uk-text-center uk-margin-auto uk-scrollspy-inview uk-margin-large"
//                     uk-scrollspy-class=""
//                 >
//                     <span className="underline-secondary">
//                         { languageStatus === 'en' ? `Photo Gallery` : `फोटो ग्यालरी`}
//                     </span>
//                 </h2>
//                 {galleryData.length > 0 ?
//                     <>
//                     <h1></h1>
//                 <div className="uk-grid-margin uk-container">
//                     <div className="tm-grid-expand uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="true">
//                         <div className="uk-width-1-1 uk-first-column">
//                             <div data-id="page#1-0-0-0" className="uk-margin uk-text-center">
//                                 <div
//                                     className="uk-child-width-1-1 uk-child-width-1-4@m uk-grid"
//                                     uk-grid="true"
//                                     uk-lightbox="toggle: a[data-type];"
//                                 >
//                                     {galleryData.length > 0 ? galleryData.map((data, index) => {
//                                             return (
//                                               <div className="" key={index}>
//                                                 <div className="uk-light">
//                                                     <a
//                                                         className="el-item uk-inline-clip uk-transition-toggle uk-link-toggle customize-unpreviewable"
//                                                         href={
//                                                             data.imageUrl && data.imageUrl !== "n/a"
//                                                                 ? data.imageUrl
//                                                                 : "assets/images/image.jpg"
//                                                         }
//                                                         data-type="image"
//                                                         data-caption={`<h4 class="uk-margin-remove">${languageStatus === 'en' ? (data.header ?? data.headerNp) : (data.headerNp ?? data.header)}</h4>`}
//                                                     >
//                                                       <div className="uk-position-cover gallery-overlay"></div>
//                                                       <picture>
//                                                         <img
//                                                             key={index}
//                                                             decoding="async"
//                                                             src={
//                                                                 data.imageUrl && data.imageUrl !== "n/a"
//                                                                     ? data.imageUrl
//                                                                     : "assets/images/image.jpg"
//                                                             }
//                                                             width="900"
//                                                             height="600"
//                                                             alt=""
//                                                             loading="lazy"
//                                                             className="el-image uk-transition-opaque"
//                                                         />
//                                                       </picture>
//                                                     </a>
//                                                   <div
//                                                       // className="uk-position-bottom-left"
//                                                   >
//                                                     <div className="uk-panel uk-padding-small uk-margin-remove-first-child">
//                                                       <h3 className="el-title uk-margin-top uk-margin-remove-bottom uk-text-italic uk-text-small" style={{ color: 'black'}}> { languageStatus === 'en' ? (data.header ?? data.headerNp) : (data.headerNp ?? data.header) } </h3>
//                                                     </div>
//                                                   </div>
//                                                 </div>
//                                             </div>
//                                             )
//                                         })
//                                         : null}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//               </> : <>
//                     <div style={{border: '1px solid', borderRadius: '5px', padding: '5px'}}>
//                       <div
//                           className="uk-flex-wrap-bottom uk-text-bold"
//                           style={{fontSize: '24px'}}
//                       >
//                           { languageStatus === 'en' ? `Photo Gallery Not Found` : `फोटो ग्यालरी भेटियन`}...
//                       </div>
//                     </div>
//                 </>}
//             </div>
//         </div>
//     </>
//     );
// }

// export default Gallery;

import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import ApiService from "../../../network/ApiService";
import { useSelector } from "react-redux";

function Gallery() {
  const { fetchGalleries } = ApiService();
  const { organizationId } = useSelector((state) => state.organization);
  const languageStatus = sessionStorage.getItem("language") || "en";

  const [open, setOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [slides, setSlides] = useState([]);
  const [galleryData, setGalleryData] = useState([]);
  const [lightboxTitle, setLightboxTitle] = useState("");

  // Helper to format photo count text properly
  const getPhotoCountText = (count) => {
    if (languageStatus === "en") {
      if (count === 1) return "1 photo available";
      return `${count} photos available`;
    } else {
      // Nepali example, change if needed
      if (count === 1) return "१ फोटो उपलब्ध छ";
      return `${count} फोटोहरू उपलब्ध छन्`;
    }
  };

  // Fetch gallery from backend
  const fetchGalleryImages = async () => {
    try {
      const response = await fetchGalleries();
      setGalleryData(response.data.messageWithImg || []);
    } catch (error) {
      console.log(error.message);
    }
  };
  // Show images in Lightbox
  const handleViewSlides = (galleryUrls, title, clickedIndex = 0) => {
    const images =
      galleryUrls && galleryUrls.length > 0
        ? galleryUrls.map((img) => ({
            src: img,
            alt: "image",
            width: 3840,
            height: 2560,
          }))
        : [];

    setSlides(images);
    setPhotoIndex(clickedIndex);
    setLightboxTitle(title);
    setOpen(true);
  };
//   console.log('checking',galleryData);

  useEffect(() => {
    if (organizationId) {
      fetchGalleryImages();
    }
  }, [organizationId]);

  return (
    <>
      <div style={{ padding: "40px 0", backgroundColor: "#f5fdf7" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 15px" }}>
          <h2
            style={{
              textAlign: "center",
              marginBottom: "40px",
              fontSize: "2rem",
              color: '#0f2495',
              fontWeight: "bold",
              borderBottom: '2px solid #0f2495',
              display: "inline-block",
            }}
          >
            {languageStatus === "en" ? "Photo Gallery" : "फोटो ग्यालरी"}
          </h2>

          {galleryData.length > 0 ? (
            <div
              className="uk-grid"
              uk-grid="true"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: "20px",
              }}
            >
              {galleryData.map((data, index) => {
                const imageUrl =
                  data?.imageUrl && data.imageUrl !== "n/a"
                    ? data.imageUrl
                    : "/assets/images/image.jpg"; // fallback image

                const title =
                  languageStatus === "en"
                    ? data.header ?? data.headerNp
                    : data.headerNp ?? data.header;

                const photoCount = data?.galleryUrls?.length || 0;

                return (
                  <button
                    key={index}
                    type="button"
                    onClick={() => handleViewSlides(data.galleryUrls, title, 0)}
                    style={{
                      cursor: "pointer",
                      border: "none",
                      padding: 0,
                      textAlign: "left",
                      borderRadius: "8px",
                      overflow: "hidden",
                      backgroundColor: "#fff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
                      transition: "transform 0.2s",
                      userSelect: "none",
                      width: "100%",
                    }}
                    aria-label={`${title}, ${getPhotoCountText(
                      photoCount
                    )}, click to view`}
                  >
                    <div style={{ width: "100%", height: "200px", overflow: "hidden" }}>
                      <img
                        src={imageUrl}
                        alt={title}
                        loading="lazy"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                          filter: "none",
                        }}
                      />
                    </div>
                    <div style={{ padding: "15px" }}>
                      <h4
                        style={{
                          margin: "0 0 5px 0",
                          fontSize: "18px",
                          fontWeight: "600",
                          color: "blue",
                        }}
                      >
                        {title}
                      </h4>
                      <p
                        style={{
                          margin: "0",
                          fontSize: "14px",
                          color: "blue",
                        }}
                      >
                        {getPhotoCountText(photoCount)}
                      </p>
                    </div>
                  </button>
                );
              })}
            </div>
          ) : (
            <div
              style={{
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "20px",
                backgroundColor: "#fff3f3",
                color: "#d9534f",
                textAlign: "center",
                fontWeight: "bold",
                marginTop: "20px",
              }}
            >
              {languageStatus === "en"
                ? "Photo Gallery Not Found"
                : "फोटो ग्यालरी भेटिएन"}
            </div>
          )}
        </div>
      </div>

      {/* Lightbox Viewer */}
      {open && (
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={slides}
          index={photoIndex}
          on={{ view: ({ index }) => setPhotoIndex(index) }}
          render={{
            slideHeader: () => (
              <div
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "20px",
                  color:'#0f2495',
                  paddingTop: "10px",
                }}
              >
                {lightboxTitle}
              </div>
            ),
          }}
        />
      )}
    </>
  );
}

export default Gallery;
